<template>
  <div class="relative flex flex-col justify-center items-center  w-5/12 rounded-2xl bg-white py-6">
    <WarningIcon class="mb-2"/>
    <h2 class="text-center font-semibold mb-2 text-yank">{{initialText}}</h2>
    <span class="mb-4 text-sm text-yank">{{postDate}}</span>
    <form class="flex flex-col md:flex-row px-5">
        <button v-for="button in buttons" v-bind:key="button.event" @click="dispatchEvent(button.event)" class="w-12/12 px-3 py-2 text-sm border-payneHot border-2 rounded-lg mr-2 mb-2 md:mb-0" type="button">{{button.message}}</button>
    </form>
</div>
</template>

<script>
import WarningIcon from '@/components/svg/WarningIcon.vue';

export default {
    name:"UploadedVideoModal",

    components:{
        WarningIcon
    },

    props: {
        buttons: {
            type: Array,
            required:true 
        },

        initialText: {
            type: String,
            required:true 
        },
    },
    
    methods: {
        dispatchEvent(event){
            this.$emit(event)
        },
    },
}
</script>